import {
  DbParams,
  Filters,
  FinalQueryParams,
  searchHistoryItem,
} from "../models/db";
import { entrezConfig } from "../util/entrezConfig";

export function getDBAxiosParams(dbParams: DbParams, filters: Filters | null) {
  const params = new URLSearchParams();

  if (dbParams.ver) params.append("ver", dbParams.ver);

  if (dbParams.retmode) params.append("retmode", dbParams.retmode);

  if (dbParams.db) params.append("db", dbParams.db);

  if (dbParams.term) params.append("term", dbParams.term);

  if (dbParams.usehistory) params.append("usehistory", dbParams.usehistory);

  if (dbParams.sort) params.append("sort", dbParams.sort);

  // if (filters && filters.dateFilter && filters.dateFilter.isApplied) {
  //   console.log("date filter values added to dbparams");
  //   params.append("datetype", "pdat");
  //   params.append("mindate", filters.dateFilter.mindate);
  //   params.append("maxdate", filters.dateFilter.maxdate);
  // }

  return params;
}

export function getFinalQueryAxiosParams(resultQueryParams: FinalQueryParams) {
  const params = new URLSearchParams();

  if (resultQueryParams.retmode)
    params.append("retmode", resultQueryParams.retmode);

  if (resultQueryParams.db) params.append("db", resultQueryParams.db);

  if (resultQueryParams.querykey)
    params.append("query_key", resultQueryParams.querykey);

  if (resultQueryParams.webenv)
    params.append("WebEnv", resultQueryParams.webenv);

  if (resultQueryParams.retstart)
    params.append("retstart", resultQueryParams.retstart.toString());

  if (resultQueryParams.retmax)
    params.append("retmax", resultQueryParams.retmax.toString());

  if (resultQueryParams.rettype)
    params.append("rettype", resultQueryParams.rettype);

  return params;
}

export function initDBParams() {
  return {
    ver: "2.0",
    retmode: "json",
    db: "",
    term: "",
    usehistory: "y",
    sort: "relevance",
    retmax: 20,
  };
}

export function initFinalQueryParams() {
  return {
    db: "",
    querykey: "",
    webenv: "",
    retstart: 0,
    retmax: entrezConfig.PageSize,
    retmode: "json",
    rettype: "docsum",
  };
}

export function initPaginationData() {
  return {
    currentPage: 1,
    totalCount: 0,
    totalPages: 1,
    pageSize: entrezConfig.PageSize,
  };
}

export function initSelectedDBExtraState() {
  return {
    finalFormattedSearchTerm: "",
    selectedColumns: [],
    queryFields: [],
  };
}

export function initFilters() {
  return {
    dateFilter: null,
  };
}

export function initSearchHistory(dbname: string) {
  console.log("Get search history");
  var key = dbname + "_SearchHistory";
  var history = localStorage.getItem(key);
  if (history) {
    var historyArrayObj = JSON.parse(history);
    return historyArrayObj;
  }

  return [];
}

export function initQueryFields(dbname: string) {
  console.log("Get search history -  Query Fields");
  var key = dbname + "_SearchHistory";
  var history = localStorage.getItem(key);
  if (history) {
    var historyArrayObj = JSON.parse(history);
    return historyArrayObj[0].queryTerms;
  }

  return [];
}

export function initFinalFormattedSearchTerm(dbname: string) {
  console.log("Get search history - Final formatted search term");
  var key = dbname + "_SearchHistory";
  var history = localStorage.getItem(key);
  if (history) {
    var historyArrayObj = JSON.parse(history);
    return historyArrayObj[0].formattedSearchTerm;
  }

  return "";
}

export function saveSearchHistory(
  dbname: string,
  searchHistory: searchHistoryItem[]
) {
  var key = dbname + "_SearchHistory";
  localStorage.setItem(key, JSON.stringify(searchHistory));
}

export function clearSearchHistory(dbname: string) {
  var key = dbname + "_SearchHistory";
  localStorage.removeItem(key);
}
